import React from "react";

const Trends = () => {
  return (
    <div className="section" id="trends">
      <h2>Recent Trends</h2>
      <div className="image-gallery-section">
        <div className="image-gallery">
          <div className="gallery-item">
            <img
              src="/images/WhoopSleep6m2025.jpeg"
              alt="Sleep Performance"
              width="300"
              height="350"
            />
            <p className="image-caption">Sleep Performance</p>
          </div>
          <div className="gallery-item">
            <img
              src="/images/WhoopDeep6m2025.jpeg"
              alt="Rem Sleep"
              width="300"
              height="350"
            />
            <p className="image-caption">Rem & Deep Sleep</p>
          </div>
          <div className="gallery-item">
            <img
              src="/images/WhoopStrain6m2025.jpeg"
              alt="Strain"
              width="300"
              height="350"
            />
            <p className="image-caption">Strain</p>
          </div>
        </div>
      </div>
      <div className="image-gallery-section">
        <div className="image-gallery">
          <div className="gallery-item">
            <img
              src="/images/appleSleep26w2025.png"
              alt="Sleep Hours"
              width="305"
              height="200"
            />
            <p className="image-caption">Sleep Hours</p>
          </div>
          <div className="gallery-item">
            <img
              src="/images/appleExercise26w2025.png"
              alt="Exercise"
              width="305"
              height="200"
            />
            <p className="image-caption">Exercise</p>
          </div>
          <div className="gallery-item">
            <img
              src="/images/appleRHR26w2025.png"
              alt="Resting Heart Rate"
              width="305"
              height="200"
            />
            <p className="image-caption">Resting Heart Rate</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trends;
